export const APP = {
  name: 'MyTownly',
  town: 'Piler, Andhra Pradesh',
  version: '1.0.0',
  privacyUrl: '/privacy',
  termsUrl: '/terms',
  supportPhone: '917730896459',
  supportWhatsapp: '917730896459',
  supportEmail: 'hello@mytownly.in',
  /** Distance-based fees are calculated from ExtraMart HyperMarket — see utils/deliveryFee.js */
  defaultPincode: '517214',
};

export const ADDRESS_LABELS = [
  { id: 'home', label: 'Home', emoji: '🏠' },
  { id: 'work', label: 'Work', emoji: '💼' },
  { id: 'other', label: 'Other', emoji: '📍' },
];
